import { render } from "./status_history_modal.vue?vue&type=template&id=a8ddfbde"
import script from "./status_history_modal.js?vue&type=script&lang=js"
export * from "./status_history_modal.js?vue&type=script&lang=js"

import "./status_history_modal.vue?vue&type=style&index=0&id=a8ddfbde&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__